import * as React from "react";
import type { RouteObject } from "react-router";
import { AppShell } from "@/components/app-shell";
import { OnboardingGate } from "@/components/onboarding-gate";
import { OnboardingPage } from "@/pages/onboarding";
import { NotFoundPage } from "@/pages/placeholder";
import { getRegisteredPublicRoutes, getRegisteredShellRoutes } from "./routes/registry";

/** Kept separate from the router so tests can mount the same routes in a memory router. */
export const routes: RouteObject[] = [
  ...getRegisteredPublicRoutes(),
  {
    path: "welcome",
    handle: { title: "Welcome to Zworks" },
    element: (
      <OnboardingGate>
        <OnboardingPage />
      </OnboardingGate>
    ),
  },
  {
    element: (
      <OnboardingGate>
        <AppShell />
      </OnboardingGate>
    ),
    children: [
      ...getRegisteredShellRoutes(),
      { path: "*", handle: { title: "Page not found" }, element: <NotFoundPage /> },
    ],
  },
];
